import content from '@/data/content.json'

export function getContent(key = '', variables = {}) {
  let text = content[key] || key

  if (Object.values(variables).length) {
    for (let variable in variables) {
      text = text.replaceAll(`{{${variable}}}`, variables[variable])
    }
  }
  return text
}
